import UIDs from "../../../../UIDs";

const uid = UIDs.screens.admin.chooseregion;

const ActionTypes = {
    SELECT_REGION: `${uid}.selectPartner`,

    LOGIN_OTHER_USER_ASYNC: `${uid}.loginOtherUserAsync`,
    LOGIN_OTHER_USER_SUCCESS: `${uid}.loginOtherUserSuccess`,
    LOGIN_OTHER_USER_FAILURE: `${uid}.loginOtherUserFailure`,
};

export { ActionTypes };
